import { isCorporateAccount, PageNotFound } from '@news-mono/component-library'
import { AppState } from '@news-mono/web-common'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { EmailPreferenceLoggedIn } from './pages/EmailPreferenceLoggedIn'
import { EmailPreferenceNotLoggedIn } from './pages/EmailPreferenceNotLoggedIn'
import { EmailPreferenceWithToken } from './pages/EmailPreferenceWithToken'

export const EPC_STORAGE_KEY = 'profileData'

export interface ProfileStorage {
    useProfileEmail: boolean
}

export const EmailPreference = () => {
    const { isLoggedIn, subscriptionType } = useSelector(
        (state: AppState) => state.authentication,
    )

    const location = useLocation()
    if (isCorporateAccount(subscriptionType)) {
        return <PageNotFound attribution={false} />
    }
    const queryParams = new URLSearchParams(location.search)
    const token = queryParams.get('token')

    if (isLoggedIn) return <EmailPreferenceLoggedIn />
    else if (token) return <EmailPreferenceWithToken />
    else {
        return <EmailPreferenceNotLoggedIn />
    }
}
